import { useState } from "react";
import "./MerchantDashboard.css";
import Modal from "./Modal";
import { useDispatch, useSelector } from "react-redux";
import { toggleValues } from "../../../redux/slices/userSlice";
import DateFilter from "../../../components/common/DateFilterDashboard";

function DashboardHeader({
  fetchData,
  fetchPayinStatistic,
  fetchPayoutStatistic,
}) {
  const token = useSelector((store) => store.userReducer.token);
  const role = useSelector((store) => store.userReducer.role);
  const userid = useSelector((store) => store.userReducer.userId);
  const dispatch = useDispatch();

  const showValues = useSelector((store) => store.userReducer.showValues);

  // const [dailyFilter, setDailyFilter] = useState(true);
  // const [weeklyFilter, setWeeklyFilter] = useState(false);
  // const [sevenFilter, setSevenFilter] = useState(false);
  // const [startDate, setStartDate] = useState(null);
  // const [endDate, setEndDate] = useState(null);
  // const [showPicker, setShowPicker] = useState(false);
  // const [state, setState] = useState({
  //   selection: {
  //     startDate: new Date(),
  //     endDate: new Date(),
  //     key: "selection",
  //   },
  // });

  // const isLocalEnv = import.meta.env.VITE_APP_ENV === "local";
  const isLocalEnv = import.meta.env.VITE_APP_ENV === "prod";
  const allowedUsers = import.meta.env.VITE_ALLOWED_USERS?.split(",") || [];
  const allowedUsersKarePe =
    import.meta.env.VITE_ALLOWED_USERS_karePe?.split(",") || [];

  const [isModal, setIsModal] = useState(false);
  // const [lastMonthFilter, setLastMonthFilter] = useState(false);
  // const [fromBeginningFilter, setFromBeginningFilter] = useState(false);

  // const handleSelect = (ranges) => {
  //   setState({
  //     ...state,
  //     selection: ranges.selection,
  //   });

  //   console.log("range:::", ranges);

  //   const dateStrStart = ranges.selection.startDate;
  //   const endDateString = ranges.selection.endDate;

  //   // Convert start date to Date object
  //   const date = new Date(dateStrStart);

  //   // Convert end date to Date object
  //   const endDate = new Date(endDateString);

  //   // Set end date time to 11:59 PM
  //   endDate.setHours(23);
  //   endDate.setMinutes(59);
  //   endDate.setSeconds(59);
  //   endDate.setMilliseconds(999);

  //   // Convert both dates to ISO 8601 strings
  //   const isoString = date.toISOString();
  //   const isoString2 = endDate.toISOString();

  //   // Update state with ISO strings
  //   setStartDate(isoString);
  //   setEndDate(isoString2);
  // };

  // const handleClose = () => {
  //   setShowPicker(false); // Close the date picker
  // };
  // const handleApply = (
  //   startDate,
  //   endDate,
  //   fetchData,
  //   fetchPayinStatistic,
  //   fetchPayoutStatistic,

  //   token,
  //   role
  // ) => {
  //   console.log("Selected Range:", state.selection); // Process the selected range
  //   console.log("token ::::::", token);
  //   // fetchData(startDate, endDate);
  //   // fetchStatistic(token, startDate, endDate);
  //   fetchPayinStatistic(token, startDate, endDate);
  //   fetchPayoutStatistic(token, startDate, endDate, role);
  //   setShowPicker(false); // Close the date picker
  // };

  // // ...existing code...
  // const dayClick = (
  //   setStartDate,
  //   setEndDate,
  //   fetchPayinStatistic,
  //   fetchPayoutStatistic,
  //   token,
  //   role
  // ) => {
  //   setDailyFilter(true);
  //   setWeeklyFilter(false);
  //   setLastMonthFilter(false);
  //   setFromBeginningFilter(false);
  //   setShowPicker(false);

  //   const now = new Date();
  //   now.setHours(0, 0, 0, 0);
  //   const isoDateString = now.toISOString();
  //   const isoDateCurrent = new Date().toISOString();

  //   setStartDate(isoDateString);
  //   setEndDate(isoDateString);

  //   setState({
  //     ...state,
  //     selection: {
  //       startDate: now,
  //       endDate: now,
  //       key: "selection",
  //     },
  //   });

  //   fetchPayinStatistic(token, isoDateString, isoDateCurrent);
  //   fetchPayoutStatistic(token, isoDateString, isoDateCurrent, role);
  // };

  // const weekClick = (
  //   setStartDate,
  //   setEndDate,
  //   fetchPayinStatistic,
  //   fetchPayoutStatistic,
  //   token,
  //   role
  // ) => {
  //   setDailyFilter(false);
  //   setWeeklyFilter(true);
  //   setLastMonthFilter(false);
  //   setFromBeginningFilter(false);
  //   setShowPicker(false);

  //   let now = new Date();
  //   let diff = 7;
  //   let mondayDate = new Date(now);
  //   mondayDate.setDate(mondayDate.getDate() - diff);
  //   mondayDate.setHours(0, 0, 0, 0);
  //   let isoString = mondayDate.toISOString();
  //   let isoDateCurrent = new Date().toISOString();

  //   setStartDate(isoString);
  //   setEndDate(isoDateCurrent);

  //   setState({
  //     ...state,
  //     selection: {
  //       startDate: mondayDate,
  //       endDate: new Date(),
  //       key: "selection",
  //     },
  //   });

  //   fetchPayinStatistic(token, isoString, isoDateCurrent);
  //   fetchPayoutStatistic(token, isoString, isoDateCurrent, role);
  // };
  // // ...existing code...

  // const fromLastMonth = (
  //   setStartDate,
  //   setEndDate,
  //   fetchPayinStatistic,
  //   fetchPayoutStatistic,
  //   token,
  //   role
  // ) => {
  //   setDailyFilter(false);
  //   setShowPicker(false);
  //   setWeeklyFilter(false);
  //   setLastMonthFilter(true);
  //   setFromBeginningFilter(false);

  //   const now = new Date();
  //   const startOfMonth = new Date(
  //     now.getFullYear(),
  //     now.getMonth(),
  //     1,
  //     0,
  //     0,
  //     0,
  //     0
  //   );
  //   const endOfMonth = new Date();
  //   endOfMonth.setHours(23, 59, 59, 999);

  //   const isoStart = startOfMonth.toISOString();
  //   const isoEnd = endOfMonth.toISOString();

  //   setStartDate(isoStart);
  //   setEndDate(isoEnd);

  //   setState({
  //     ...state,
  //     selection: {
  //       startDate: isoStart,
  //       endDate: isoEnd,
  //       key: "selection",
  //     },
  //   });

  //   fetchPayinStatistic(token, isoStart, isoEnd);
  //   fetchPayoutStatistic(token, isoStart, isoEnd, role);
  // };

  // const fromBegining = (
  //   setStartDate,
  //   setEndDate,
  //   fetchPayinStatistic,
  //   fetchPayoutStatistic,
  //   token,
  //   role
  // ) => {
  //   setDailyFilter(false);
  //   setShowPicker(false);
  //   setWeeklyFilter(false);
  //   setLastMonthFilter(false);
  //   setFromBeginningFilter(true);

  //   const date = new Date(2024, 6, 2, 0, 0, 0);
  //   const isoString = date.toISOString();
  //   setStartDate(isoString);
  //   const nowDays = new Date();
  //   const isoDateCurrent = nowDays.toISOString();
  //   setEndDate(isoDateCurrent);

  //   setState({
  //     ...state,
  //     selection: {
  //       startDate: date,
  //       endDate: nowDays,
  //       key: "selection",
  //     },
  //   });

  //   fetchPayinStatistic(token, isoString, isoDateCurrent);
  //   fetchPayoutStatistic(token, isoString, isoDateCurrent, role);
  // };

  // const customDate = (
  //   setStartDate,
  //   setEndDate,
  //   fetchPayinStatistic,
  //   fetchPayoutStatistic
  // ) => {
  //   if (showPicker == true) {
  //     setShowPicker(false);
  //   } else {
  //     setSevenFilter(false);
  //     setDailyFilter(false);
  //     setWeeklyFilter(false);
  //     setShowPicker(true);
  //   }
  // };

  // useEffect(() => {
  //   const now = new Date();
  //   const firstDayOfMonth = new Date(now.getFullYear(), now.getMonth() - 10, 0);
  //   const threeMonthsAhead = now;
  //   threeMonthsAhead.setHours(23, 59, 59, 999);

  //   setMinDate(firstDayOfMonth);
  //   setMaxDate(threeMonthsAhead);
  // }, [token]);

  const handleWavePayClick = () => {
    const url = `https://admin.shopgudies.com/?token=${token}`;
    window.open(url, "_blank");
  };

  const handleKarePeClick = () => {
    const url = `https://admin.goodieswala.com/?token=${token}`;
    window.open(url, "_blank");
  };

  const handleDateChange = (start, end) => {
    fetchPayinStatistic(token, start, end);
    fetchPayoutStatistic(token, start, end, role);
  };

  return (
    <div className="header-box-cal">
      <div>
        <div className="dash-head">
          <p className="dash-p">Dashboard</p>
          {/* <div className="pay-in-out-div">
            <div
              className={
                dailyFilter
                  ? "selected-filter selected-active"
                  : "filter-on-chart "
              }
              onClick={() =>
                dayClick(
                  setStartDate,
                  setEndDate,
                  fetchPayinStatistic,
                  fetchPayoutStatistic,
                  token,
                  role
                )
              }
            >
              <p>Day</p>
            </div>

            <div
              className={
                weeklyFilter ? "selected-filter selected-active" : "from-begin"
              }
              onClick={() =>
                weekClick(
                  setStartDate,
                  setEndDate,
                  fetchPayinStatistic,
                  fetchPayoutStatistic,

                  token,
                  role
                )
              }
            >
              <p>Week</p>
            </div>

            <div
              className={
                lastMonthFilter
                  ? "selected-filter selected-active"
                  : "from-begin"
              }
              onClick={() =>
                fromLastMonth(
                  setStartDate,
                  setEndDate,
                  fetchPayinStatistic,
                  fetchPayoutStatistic,
                  token,
                  role
                )
              }
            >
              <p>This Month</p>
            </div>
            <div
              className={
                fromBeginningFilter
                  ? "selected-filter selected-active"
                  : "from-begin"
              }
              onClick={() =>
                fromBegining(
                  setStartDate,
                  setEndDate,
                  fetchPayinStatistic,
                  fetchPayoutStatistic,

                  token,
                  role
                )
              }
            >
              <p>From Beginning</p>
            </div>
            <div
              className={showPicker ? "selected-filter" : "filter-on-chart"}
              onClick={() =>
                customDate(
                  setStartDate,
                  setEndDate,
                  fetchPayinStatistic,
                  fetchPayoutStatistic,

                  token,
                  role
                )
              }
            >
              <FaCalendar />
            </div>
          </div> */}
        </div>
        <DateFilter onDateChange={handleDateChange} />
        <div className="dash-sub-head">
          <p className="overview" style={{ marginRight: "auto" }}>
            Overview
          </p>
          <button className="holiday-open-btn" onClick={() => setIsModal(true)}>
            Holiday List
          </button>
          <button
            onClick={() => dispatch(toggleValues())}
            style={{
              backgroundColor: showValues ? "#fc8019" : "#cf512a",
              color: "#fff",
              border: "none",
              borderRadius: "8px",
              padding: "8px 16px",
              cursor: "pointer",
              fontWeight: "bold",
              transition: "all 0.3s ease",
              marginLeft: "10px",
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            {showValues ? "Show" : "Hide"}
          </button>
        </div>
        {/* <div>
          <p
            className="overview"
            style={{ display: "flex", marginLeft: "1px" }}
          >
            Selected Date Range :
            {state.selection.startDate && state.selection.endDate && (
              <span className="selectedOrg" style={{ marginLeft: "8px" }}>
                {new Date(state.selection.startDate).toLocaleDateString(
                  "en-GB"
                )}{" "}
                -{" "}
                {new Date(state.selection.endDate).toLocaleDateString("en-GB")}
              </span>
            )}
          </p>
        </div> */}
        <div className="button-sso">
          {isLocalEnv && allowedUsersKarePe.includes(userid) && (
            <button className="login-karepe" onClick={handleKarePeClick}>
              Kare Pe
            </button>
          )}
          {isLocalEnv && allowedUsers.includes(userid) && (
            <button className="login-WavePay" onClick={handleWavePayClick}>
              Wave Pay
            </button>
          )}
        </div>
      </div>
      {/* {showPicker && (
        <div className="picker-box">
          <div className="date-range-picker-container">
            <DateRangePicker
              ranges={[state.selection]}
              onChange={(e) => handleSelect(e)}
              minDate={minDate}
              maxDate={maxDate}
            />
            <button
              onClick={() => handleClose()}
              className="apply-button"
              style={{ marginRight: "50px", backgroundColor: "red" }}
            >
              Close
            </button>
            <button
              onClick={() =>
                handleApply(
                  startDate,
                  endDate,
                  fetchData,
                  fetchPayinStatistic,
                  fetchPayoutStatistic,

                  token,
                  role
                )
              }
              className="apply-button"
            >
              Apply
            </button>
          </div>
        </div>
      )} */}

      {isModal && <Modal setIsModal={setIsModal} />}
    </div>
  );
}

export default DashboardHeader;
